const universityPrograms = {
    "usc": [
        {"value": "General_llm", "label": "General LLM"},
        {"value": "Two_year_llm", "label": "Two-Year LLM"},
        {"value": "ADR", "label": "LLM in Alternative Dispute Resolution"},
        {"value": "adr", "label": "LLM in Alternative Dispute Resolution"},
        {"value": "business_law", "label": "LLM in Business Law"},
        {"value": "IBEL", "label": "LLM in International Business and Economic Law (LLM in IBEL)"},
        {"value": "MAEL", "label": "LLM in Media and Entertainment Law"},
        {"value": "PLCS", "label": "LLM in Privacy Law and Cybersecurity"},
        {"value": "Online_llm", "label": "Online LLM"},
        {"value": "MCL", "label": "Master of Comparative Law"},
        {"value": "MSL_online", "label": "Master of Studies in Law (MSL) - Online"},
        {"value": "MSL_onCampus", "label": "Master of Studies in Law (MSL) - On Campus"},
        {"value": "MDR", "label": "Master of Dispute Resolution"},
        {"value": "MITLE", "label": "Master of International Trade Law and Economics"},
        {"value": "MIELR", "label": "Master of Science in Innovation Economics, Law and Regulation"},
        {
            value: "llm_ai_technology_law",
            label: "LLM in AI and Technology Law",
        },
        {
            value: "llm_sports_law_negotiation",
            label: "LLM in Sports Law and Negotiation",
        },
        {
            value: "online_llm_media_entertainment_law",
            label: "Online LLM in Media and Entertainment Law",
        },
    ],
        usc_gis: [
        { value: "gist", label: "M.S. in Geographic Information Science and Technology (GIST)" },
        { value: "hsgi", label: "M.S. in Human Security and Geospatial Intelligence (HSGI)" },
        { value: "spds", label: "M.S. in Spatial Data Science (M.S. SPDS)" },
        { value: "seda", label: "Master of Science in Spatial Economics and Data Analysis (M.S. SEDA)" },
        {
            value: "gsec",
            label: "M.A. in Global Security Studies (M.A. GSEC)",
        },
        { value: "geh", label: "M.S. in Geodesign, Environment and Health" },
    ],
    usc_dornsife: [
        { value: "ms_aee", label: "MS Applied Economics and Econometrics (MS AEE)" },
        { value: "ms_mds", label: "MS Mathematical Data Science" },
        { value: "ms_mfp", label: "MS in Mathematical Finance Program" },
    ],
    usc_mann: [
        { value: "ms_mpt", label: "MS in Molecular Pharmacology and Toxicology" },
        { value: "ms_ps", label: "MS in Pharmaceutical Sciences" },
        { value: "ms_cet", label: "MS in Clinical and Experimental Therapeutics" },
        { value: "ms_pds", label: "MS in Pharmacoepidemiology and Drug Safety" },
        { value: "progressive_ms_cet", label: "Progressive MS in Clinical and Experimental Therapeutics" },
        { value: "ms_bm", label: "MS in Biopharmaceutical Marketing" },
        { value: "progressive_ms_bm", label: "Progressive MS in Biopharmaceutical Marketing" },
        { value: "ms_hda", label: "MS in Healthcare Decision Analysis" },
        { value: "progressive_ms_hda", label: "Progressive MS in Healthcare Decision Analysis" },
        { value: "ms_pep", label: "MS in Pharmaceutical Economics and Policy" },
        { value: "ms_ctm", label: "MS in Clinical Trial Management" },
        { value: "ms_mdd", label: "MS in Management of Drug Development" },
        { value: "ms_mpq", label: "MS in Medical Product Quality" },
        { value: "ms_rm", label: "MS in Regulatory Management" },
        { value: "ms_rs", label: "MS in Regulatory Science" }
    ],
    usc_iovine: [
        { value: "ma_idbt", label: "M.S. Integrated Design, Business and Technology" }
    ],
    usc_annenberg: [
        { value: "ms_cds", label: "MS in Communication Data Science" },
        { value: "ms_cm", label: "Master of Communication Management" },
        { value: "online_ms_dmm", label: "Online MS in Digital Media Management" },
        { value: "ms_dsm", label: "MS in Digital Social Media" },
        { value: "dd_gmc", label: "Dual Degree in Global Media and Communication" },
        { value: "ms_journalism", label: "MS in Journalism" },
        { value: "master_public_diplomacy", label: "Master of Public Diplomacy" },
        { value: "ma_public_relation_and_advertising", label: "MA in Public Relations and Advertising" },
        { value: "online_ms_prism", label: "Online MS in Public Relations Innovation, Strategy and Management" },
        { value: "ma_specialized_journalism", label: "MA in Specialized Journalism" },
        { value: "ms_sjac", label: "MA in Specialized Journalism (Arts and Culture)" }
    ],
    "Dickinson": [
        {"value": "carlisle", "label": "Carlisle"},
        {"value": "university_park", "label": "University Park"},
    ],
    "gateway": [
        {"value": "advertising", "label": "Advertising with Gateway"},
        {"value": "candidate_advocacy", "label": "Finding jobs in higher-ed"},
        {"value": "executive_search", "label": "Hiring higher-ed executives"},
        {"value": "global_scope_360", "label": "An external review via GlobalScope 360"},
        {"value": "on_demand_staffing", "label": "Hiring on-demand international education staff"},
        {"value": "IPAC", "label": "International partnerships and collaborations"},
    ],
    "esigelec": [
        {"value": "master_of_technology", "label": "Master of Technology"}
    ],
    "GW Law": [
        {"value": "general_llm", "label": "General LLM"}
    ],
    "SMU": [
        {"value": "foreign_llm", "label": "LL.M. for Foreign Law School Graduates"}
    ],
    "Texas": [
        {"value": "general_llm", "label": "On-Campus LLM - General Studies"}
    ],
    "georgetown": [
        {"value": "general_llm", "label": "General/International Legal Studies"}
    ],
    "ucla": [
        {"value": "entertainment", "label": "LLM in Media, Entertainment, and Technology Law and Policy"},
        {"value": "international", "label": "LLM in International and Comparative Law"},
        {"value": "human_rights", "label": "LLM in Human Rights"},
    ],
    "boston": [
        {"value": "american_law_program", "label": "LLM in American Law"},
        {"value": "banking_law_program", "label": "LLM in Banking and Financial Law"},
        {"value": "intellectual_property", "label": "LLM in Intellectual Property & Information Law"},
        {"value": "texation_program", "label": "LLM in Taxation"},
        {"value": "two_year_llm_program", "label": "Two-Year LLM Program"},
        {"value": "msl_tax_program", "label": "Master in the Study of Tax Law"},
    ],
    "UNH Law": [
        {"value": "ip_law", "label": "Intellectual Property (LL.M.)"},
        {"value": "tech_law", "label": "Commerce and Technology Law (LL.M.)"},
        {"value": "criminal_law", "label": "International Criminal Law and Justice (LL.M.)"},
        {"value": "mctl", "label": "Master's in Commerce and Technology Law"},
        {"value": "miclj", "label": "Master's in International Criminal Law and Justice"},
        {"value": "mip", "label": "Master's in Intellectual Property"},
        {"value": "ip_certificate", "label": "Intellectual Property (Graduate Certificate)"},
        {"value": "tech_law_certificate", "label": "Commerce and Technology (Graduate Certificate)"},
    ],
}

export function get_program_label(programValue, university){
     // Check if the university exists in the dataset
    if (universityPrograms[university]) {
        // Find the program with the matching value
        const program = universityPrograms[university].find(
        (p) => p.value === programValue
        );
        return program ? program.label : programValue; 
    }
    return programValue; 
}